var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from './model';
import { OriginalPhoto } from './original-photo';
import { ProductItem } from './product-item';
import { CartItem } from './cart-item';
var Photo = /** @class */ (function (_super) {
    __extends(Photo, _super);
    function Photo(data) {
        var _this = _super.call(this, data) || this;
        if (data.original_photo) {
            _this.original_photo = new OriginalPhoto(data.original_photo);
        }
        if (data.product_item) {
            _this.product_item = new ProductItem(data.product_item);
        }
        if (data.cart_item) {
            _this.cart_item = new CartItem(data.cart_item);
        }
        return _this;
    }
    Photo.prototype.resetPosition = function () {
        this.position_x = 0;
        this.position_y = 0;
        this.scale = 1;
        this.rotate = 0;
    };
    Photo.prototype.setOrientation = function (orientation) {
        this.orientation = orientation;
    };
    Photo.prototype.toggleOrientation = function () {
        if ('landscape' === this.orientation) {
            this.setOrientation('portrait');
            return;
        }
        if ('portrait' === this.orientation) {
            this.setOrientation('landscape');
            return;
        }
    };
    Photo.prototype.setProductItem = function (productItem) {
        this.product_item = productItem;
        this.product_item_id = productItem.id;
    };
    Photo.prototype.getUri = function () {
        return '/storage/photos/' + this.name;
    };
    Photo.prototype.getFrameImageUri = function () {
        return "/images/product-items/" + this.product_item.id + "-" + this.orientation + ".png?v1";
    };
    Photo.prototype.getOuterSize = function (maxWidth, maxHeight) {
        return this.product_item.getOuterSize(this.orientation, maxWidth, maxHeight);
    };
    Photo.prototype.getFrameSizes = function (maxWidth, maxHeight) {
        return this.product_item.getFrameSizes(this.orientation, maxWidth, maxHeight);
    };
    Photo.prototype.getMatboardSizes = function (maxWidth, maxHeight, considerFrame) {
        if (considerFrame === void 0) { considerFrame = false; }
        var maxMatboardWidth = maxWidth;
        var maxMatboardHeight = maxHeight;
        if (considerFrame) {
            var frameSizes = this.getFrameSizes(maxWidth, maxHeight);
            maxMatboardWidth = maxWidth - (frameSizes ? frameSizes.left + frameSizes.right : 0);
            maxMatboardHeight = maxHeight - (frameSizes ? frameSizes.top + frameSizes.bottom : 0);
        }
        return this.product_item.getMatboardSizes(this.orientation, maxMatboardWidth, maxMatboardHeight);
    };
    Photo.prototype.getInnerSize = function (maxWidth, maxHeight) {
        return this.product_item.getInnerSize(this.orientation, maxWidth, maxHeight);
    };
    Photo.prototype.getDpi = function (scale, rotate) {
        var _a;
        if (scale === void 0) { scale = null; }
        if (rotate === void 0) { rotate = null; }
        var originalDpi = this.getOriginalDpi(rotate);
        if (!originalDpi) {
            return null;
        }
        return originalDpi / ((_a = scale !== null && scale !== void 0 ? scale : this.scale) !== null && _a !== void 0 ? _a : 1);
    };
    Photo.prototype.getOriginalDpi = function (rotate) {
        var _a;
        if (rotate === void 0) { rotate = null; }
        if (!this.original_photo) {
            return null;
        }
        var isUpsideDown = [90, 270].includes(Math.abs((_a = rotate !== null && rotate !== void 0 ? rotate : this.rotate) !== null && _a !== void 0 ? _a : 0));
        // divide by the scale, if the picture is scaled it means the original size basically shrinked
        var width = (isUpsideDown ? this.original_photo.height : this.original_photo.width);
        var height = (isUpsideDown ? this.original_photo.width : this.original_photo.height);
        var sizes = this.product_item.getSizesInInch(this.orientation);
        if (!sizes) {
            return null;
        }
        return Math.min(width / sizes.width, height / sizes.height);
    };
    return Photo;
}(Model));
export { Photo };
